import { render } from "./CatalogWklady.vue?vue&type=template&id=41ef092c&scoped=true"
import script from "./CatalogWklady.vue?vue&type=script&lang=js"
export * from "./CatalogWklady.vue?vue&type=script&lang=js"

import "./CatalogWklady.vue?vue&type=style&index=0&id=41ef092c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ef092c"]])

export default __exports__